export default __webpack_public_path__ + "img/kingno1-35e77efe.png";